import XLSX from "xlsx";
import { saveAs } from 'file-saver';

const saveExcel = (
    resolvedData,
    fileName = 'Таблица'
) => {

    const wb = XLSX.utils.book_new();

    wb.Props = {
        Title: "Sheet",
        Subject: "Test",
        Author: "Nintegra",
        CreatedDate: new Date()
    };

    wb.SheetNames.push("Таблица")

    // resolvedData может быть DOM-таблицей или массивом строк (array of arrays)
    const ws = Array.isArray(resolvedData)
        ? XLSX.utils.aoa_to_sheet(resolvedData)
        : XLSX.utils.table_to_sheet(resolvedData)

    wb.Sheets["Таблица"] = ws;

    const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'});

    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    saveAs(new Blob([s2ab(wbout)], {type: "application/octet-stream"}), `${fileName}.xlsx`);

}

export default saveExcel;